import { Link, Text, View } from "@react-pdf/renderer";

import { styles } from "../../Tables";

export const TableRowSanitarniEvdListaDefinisanihTacakaHeader: React.FC<{
  uposlenik: string;
  dokument: string;
  vaziOd: string;
  vaziDo: string;
}> = ({ uposlenik, dokument, vaziOd, vaziDo }) => (
  <View style={styles.tableRow}>
    <View style={styles.tableCol}>
      <Text>{uposlenik}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{vaziOd}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{vaziDo}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{dokument}</Text>
    </View>
  </View>
);

export const TableRowSanitarniEvdListaDefinisanihTacaka: React.FC<{
  uposlenik: string;
  dokument?: string;
  vaziOd: string;
  vaziDo: string;
  slikaRes: string;
}> = ({ slikaRes, uposlenik, dokument, vaziOd, vaziDo }) => (
  <View style={styles.tableRow} wrap={false}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{uposlenik}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{vaziOd}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{vaziDo}</Text>
    </View>
    <View style={styles.tableCol}>
      {dokument && (
        <Link src={dokument} style={{ ...styles.tableCell, ...styles.link }}>
          {slikaRes}
        </Link>
      )}
    </View>
  </View>
);
